import { createApi } from "@reduxjs/toolkit/query/react"

import { axiosBaseQuery } from "./base-query"

/**
 * The one RTK Query api behind every endpoint file.
 *
 * Each file injects into this instance, so the store holds a single cache
 * reducer and a single middleware instead of one per domain, and a tag
 * invalidated by one file's mutation reaches another file's query — which
 * separate apis could not do.
 *
 * Every tag any endpoint provides or invalidates has to be declared here:
 * `injectEndpoints` cannot add tag types.
 */
export const baseApi = createApi({
  reducerPath: "api",
  baseQuery: axiosBaseQuery(),
  tagTypes: [
    "ActivityPricing",
    "AdminInspirations",
    "AdminPlaceReviews",
    "AdminUsers",
    "Agent",
    "AgentRuns",
    "Airlines",
    "AssistantGreeting",
    "AssistantSuggestions",
    "Chats",
    "Collaborators",
    "Collection",
    "Collections",
    "CollectionsStats",
    "Comments",
    "CommunityFeed",
    "CurrentUserPlaceReview",
    "DetailedEventActor",
    "DetectedTripReview",
    "DetailedInspiration",
    "DetailedPlace",
    "EarlyAccessFeatureFlags",
    "EmailGeneration",
    "EventActorEvents",
    "Events",
    "FavoriteCollections",
    "FeatureFlag",
    "FlightPriceAlertMatch",
    "FlightQuoteDetails",
    "FlightSearchSummary",
    "Bookings",
    "FolioDocuments",
    "FolioForwardingEmails",
    "ForYouRibbonPlaces",
    "ForYouRibbons",
    "HotelAvailability",
    "HotelRoom",
    "ImagePacks",
    "InspirationItems",
    "Inspirations",
    "Itinerary",
    "ItineraryEvents",
    "ItineraryReview",
    "Location",
    "LocationSearch",
    "LoyaltyArtifacts",
    "LoyaltyDataIssues",
    "LoyaltyPrograms",
    "LoyaltySources",
    "MediaCollections",
    "MediaFiles",
    "MediaGuides",
    "MediaLinks",
    "MediaTripRefs",
    "MediaVideos",
    "NavTrips",
    "NeedsAttention",
    "Notifications",
    "OrgChatInsights",
    "OrgChats",
    "OrgCrawledUrls",
    "OrgCrawls",
    "OrgFeedbacks",
    "OrgInspirations",
    "OrgKeyFacts",
    "OrgMembers",
    "OrgPermissions",
    "OrgPlaces",
    "OrgUsers",
    "OrgVanityReports",
    "Organization",
    "PipelineRun",
    "PipelineRunList",
    "Place",
    "PlaceReviewConfig",
    "PlaceReviews",
    "PlaceTripRefs",
    "PriceQuote",
    "ProactiveAgent",
    "PublicUserCollections",
    "RankedHotelAvailability",
    "RecentItems",
    "RelatedPlaces",
    "Route",
    "SavedGuides",
    "SavedPlaceRefs",
    "SavedPlaces",
    "Stats",
    "TravelStory",
    "Trip",
    "TripAdvice",
    "TripCounts",
    "TripDetails",
    "Trips",
    "TripsCalendar",
    "UnreadCount",
    "UserInspirations",
    "WebEvents",
  ],
  endpoints: () => ({}),
})
